
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Plus, Search, Edit, Trash2, Tags } from 'lucide-react';
import { NewProviderModal } from '@/components/Providers/NewProviderModal';
import { NewProviderTypeModal } from '@/components/Providers/NewProviderTypeModal';

export const ProvidersList: React.FC = () => {
  const [showNewProviderModal, setShowNewProviderModal] = useState(false);
  const [showNewTypeModal, setShowNewTypeModal] = useState(false);

  const providers = [
    {
      id: '1',
      nombre: 'Catering Delicious',
      tipo: 'Catering',
      tel: '+52 55 7777 8888',
      email: 'info@delicious.com'
    },
    {
      id: '2',
      nombre: 'Foto Estudio Pro',
      tipo: 'Fotografía',
      tel: '+52 55 9999 0000',
      email: 'contacto@fotopro.com'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-900">Proveedores</h1>
        <div className="flex space-x-3">
          <Button 
            onClick={() => setShowNewTypeModal(true)}
            variant="outline"
            className="border-blue-600 text-blue-600 hover:bg-blue-50"
          >
            <Tags className="w-4 h-4 mr-2" />
            Nuevo Tipo
          </Button>
          <Button 
            onClick={() => setShowNewProviderModal(true)}
            className="bg-blue-600 hover:bg-blue-700 text-white"
          >
            <Plus className="w-4 h-4 mr-2" />
            Nuevo Proveedor
          </Button>
        </div>
      </div>

      {/* Filtros */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex gap-4">
            <div className="flex-1">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                <Input
                  placeholder="Buscar proveedores..."
                  className="pl-10"
                />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Tabla de proveedores */}
      <Card>
        <CardHeader>
          <CardTitle>Lista de Proveedores</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nombre</TableHead>
                <TableHead>Tipo</TableHead>
                <TableHead>Teléfono</TableHead>
                <TableHead>Email</TableHead>
                <TableHead className="text-right">Acciones</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {providers.map((provider) => (
                <TableRow key={provider.id}>
                  <TableCell className="font-medium">{provider.nombre}</TableCell>
                  <TableCell>{provider.tipo}</TableCell>
                  <TableCell>{provider.tel}</TableCell>
                  <TableCell>{provider.email}</TableCell>
                  <TableCell className="text-right">
                    <div className="flex justify-end gap-2">
                      <Button variant="outline" size="sm">
                        <Edit className="w-4 h-4" />
                      </Button>
                      <Button variant="outline" size="sm">
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <NewProviderModal 
        open={showNewProviderModal} 
        onOpenChange={setShowNewProviderModal} 
      />
      <NewProviderTypeModal 
        open={showNewTypeModal} 
        onOpenChange={setShowNewTypeModal} 
      />
    </div>
  );
};
